import watchPostLiveReasonSaga from './postLive'

export default () => [watchPostLiveReasonSaga()]
